/**
 *
 * UnsupportedBrowser
 *
 */
import getBrowserName from '~/lib/getBrowserName'
import styles from './index.module.scss'
import LogoAnimated from '~/icons/LogoAnimated'

const UnsupportedBrowser = () => {
	const browserName = getBrowserName()

	return (
		<div className={styles.cont}>
			<LogoAnimated />
			<h1 className={styles.title}>Browser Not Supported</h1>
			<p className={styles.message}>
				Oyλo requires a Chromium-based browser (Chrome, Edge, Brave, Opera) or Safari.
			</p>
			<p className={styles.detected}>Detected: {browserName}</p>
		</div>
	)
}

export default UnsupportedBrowser
